import React from 'react';
import { Route } from 'react-router';
import PolicyEnforcer from './route-policy-enforcer';

export const useRoutes = (pathPrefix, definitions) => {
  // No definitions found
  if (Array.isArray(definitions) === false || definitions.length === 0) {
    return null;
  }

  // Resolve pathPrefix
  if (typeof pathPrefix !== 'string' || pathPrefix.trim().length === 0) {
    pathPrefix = '/';
  } else {
    pathPrefix = pathPrefix.trim();
  }

  // Resolve the routes from the definitions
  let routes = [];

  for (let i = 0; i < definitions.length; i++) {
    // Validate the definition
    const path = definitions[i]?.path ?? '';
    const isPathDefined = typeof path === 'string' && path.trim().length > 0;

    const isIndexRoute = (definitions[i]?.index ?? false) === true;

    // Skip if the path is not defined and it's not marked as an index route
    if (isPathDefined === false && isIndexRoute === false) {
      continue;
    }

    let routeAttr = {
      element: definitions[i]?.component ?? null // if no component was defined, use null
    };

    if (isPathDefined === true) {
      routeAttr.path = path.trim();
    } else {
      routeAttr.index = true;
    }

    let r = (
      <Route
        key={`route-${i}`}
        {...routeAttr}
      />
    );

    // Add the policy enforcer component if the route has a policy defined
    const policies = definitions[i]?.policies ?? [];
    if (Array.isArray(policies) === true && policies.length > 0) {
      r = (
        <Route
          key={`route-policy-${i}`}
          element={<PolicyEnforcer policies={policies} />}
        >
          {r}
        </Route>
      );
    }

    routes.push(r);
  }

  // If all the routes are filtered out return null
  if (routes.length === 0) {
    return null;
  }

  return <Route path={pathPrefix}>{routes}</Route>;
};
